// Follow visible form order rather than schema order, including custom controls
// whose registered value is a hidden input or has no focusable form ref.
export function focusFirstInvalidField(form, errors) {
  if (!form) return;
  const field = Array.from(form.querySelectorAll("[data-validation-field]"))
    .find((element) => errors[element.dataset.validationField]);
  if (!field) return;

  field.scrollIntoView({ behavior: "smooth", block: "center" });
  const control = field.querySelector(
    'input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled)'
  );
  (control || field).focus({ preventScroll: true });
}
